export function validateAccountNumber(kontonummer: string): boolean {
  const cleaned = kontonummer.toString().replace(/[,.\s]/g, "");
  if (cleaned.length !== 11) return false;

  let kontrollsiffer = 2;
  let sum = 0;
  for (let i = cleaned.length - 2; i >= 0; --i) {
    sum += Number(cleaned.charAt(i)) * kontrollsiffer;
    kontrollsiffer += 1;
    if (kontrollsiffer > 7) kontrollsiffer = 2;
  }

  const result = 11 - (sum % 11);
  const checkDigit = result === 11 ? 0 : result;
  return parseInt(cleaned.charAt(cleaned.length - 1), 10) === checkDigit;
}

export function validateSubscriptionFeePercent(val: string): boolean {
  const num = Number(val);
  return !isNaN(num) && num >= 0 && num <= 3;
}
